/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, October 27th 2021, 5:26:06 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { UUID4 } from "lib/types";
import { schemaBuilder } from "lib/validation";

export interface ProcessTemplateArtifact {
  readonly artifact_tag?: string;
  artifact_guid?: UUID4;
  artifact_org: UUID4;
}

export type ProcessTemplateArtifactType<T> = Omit<T, "artifact_tag" | "artifact_guid">; // To be used in related fields where we dont need to access the artifact tag and guid

export type ProcessTemplateArtifactSchemaType<T> = schemaBuilder.SchemaOf<Omit<T, "artifact_tag">>;

export const ProcessTemplateArtifactValidationSchema: ProcessTemplateArtifactSchemaType<ProcessTemplateArtifact> =
  schemaBuilder.object().shape({
    artifact_guid: schemaBuilder.string().uuid().nullable(),
    artifact_org: schemaBuilder.string().required("Organization Must be Set for a Process Template Artifact"),
  });
